import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const CTASection = ({ onBookDemo, onGetStarted }) => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl bg-white border border-gray-200 shadow-xl overflow-hidden">
          {/* Background Pattern */}
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,0,0,0.03) 1px, transparent 0)',
              backgroundSize: '32px 32px'
            }}
          />
          
          {/* Gradient Orbs */}
          <div className="absolute top-0 right-1/4 w-64 h-64 bg-purple-100 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-blue-100 rounded-full blur-3xl" />

          {/* Content */}
          <div className="relative px-6 py-16 lg:px-12 lg:py-24">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Build AI Agents for customer support{' '}
                <span className="text-gray-400">and beyond</span>
              </h2>
              <p className="text-gray-600 text-lg mb-10 max-w-xl mx-auto">
                Ready to explore how AI AutoBots can help your team? Let&apos;s talk.
              </p>
              
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Button
                  onClick={onBookDemo}
                  size="lg"
                  className="bg-gray-900 text-white hover:bg-gray-800 font-medium px-8 py-6 text-base rounded-xl group"
                >
                  Book a Demo
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  onClick={onGetStarted}
                  variant="outline"
                  size="lg"
                  className="border-gray-300 text-gray-700 hover:bg-gray-100 px-8 py-6 text-base rounded-xl"
                >
                  Get Started
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
